module.exports = __webpack_public_path__ + "img/2.1541f730.png";